import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { CnpjService } from "src/app/core/services/cnpj-service";
import { UsuarioService } from "src/app/core/services/usuario-service";
import Swal from "sweetalert2";
import { InitProvider } from "src/app/core/services/init-provider";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { formatDate } from '@angular/common';
import { validaCNPJ as validaCNPJValidator } from "src/app/core/validators/cnpj.validators";
declare var $: any;

@Component({
  selector: "novo-representante",
  templateUrl: "./novo-representante.component.html",
  styleUrls: ["./novo-representante.component.css"],
})
export class NovoRepresentanteComponent implements OnInit {
  SITE: ConfiguracoesSite;
  public nomeLabel1 = "Razão Social";
  public nomeLabel2 = "Fantasia";
  public documentMask = "00.000.000/0000-00";
  public documentLabel1 = "CNPJ";
  public documentLabel2 = "IE";
  public dateFormat = $localize`DD/MM/YYYY`
  public error: Boolean = false;
  public errorMsg: String;
  public form: FormGroup;
  public ufs: string[] = [
    "AC",
    "AL",
    "AM",
    "AP",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MG",
    "MS",
    "MT",
    "PA",
    "PB",
    "PE",
    "PI",
    "PR",
    "RJ",
    "RN",
    "RO",
    "RR",
    "RS",
    "SC",
    "SE",
    "SP",
    "TO",
  ];
  public cities: [] = [];
  public tipo_empresa = [
    { id: 1, label: "EMPRESA NORMAL" },
    { id: 2, label: "EPP - PEQUENO PORTE" },
    { id: 3, label: "EPP SIMPLES" },
    { id: 4, label: "ME - MICRO EMPRESA" },
  ];
  public tipo_empresaPF = [{ id: 0, label: "CONSUMIDOR FINAL" }];
  public tipo_empresaPJ = [
    { id: 1, label: "EMPRESA NORMAL" },
    { id: 2, label: "EPP - PEQUENO PORTE" },
    { id: 3, label: "EPP SIMPLES" },
    { id: 4, label: "ME - MICRO EMPRESA" },
  ];

  public tableInfoDoc;
  public cnpjHistory;

  @Input() registro: boolean = false;
  @Input() edit: boolean = false;
  @Input() cadastroCliente: boolean;
  @Input() selectedClient: any = {};
  @Output() page = new EventEmitter<number>();

  constructor(
    public toastService: ToastrService,
    private formBuilder: FormBuilder,
    public usuarioService: UsuarioService,
    private cnpjService: CnpjService,
    public initProvider: InitProvider,
    private localeService: BsLocaleService,
    private router: Router
  ) {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.SITE = Configuracoes.SITE;
    this.localeService.use("pt-custom");
    this.form = this.formBuilder.group({
      nome: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      numdocumento: ["", Validators.required],
      //endereço
      endereco: ["", Validators.required],
      numero: ["", Validators.required],
      cep: ["", Validators.required],
      bairro: ["", Validators.required],
      uf: ["", Validators.required],
      cidade: ["", Validators.required],
      tipodocumento: ["", Validators.required],
      nascimento: [""],
      contato: [""],
      complemento: [""],
      dddWhatsapp: ["", [Validators.required]],
      telefoneWhatsapp: [
        "", [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern(/^9\d{4}-\d{4}$/),
        ],
      ],
      ddd: ["", []],
      telefone: [
        "",
        [
          Validators.minLength(9),
          Validators.pattern(/^[2-5]\d{3}-?\d{4}$/)
        ],
      ],
      fantasia: ["", Validators.required],
      observacao: [""],
    });
  }

  consultaCnpj(event, callCnpjCancel = false) {
    if (callCnpjCancel) {
      return
    }
    let cnpj = event.target.value;

    if (this.form.controls.tipodocumento.value != "CNPJ") {
      return;
    }

    if (this.form.controls.numdocumento.invalid) {
      if (cnpj.length > 12) Swal.fire("CNPJ", "CNPJ Inválido", "error");
      return;
    }
    if (cnpj == this.cnpjHistory) {
      return;
    }

    this.cnpjHistory = cnpj;
    this.cnpjService.getCnpjAPIAgilb2b(
      cnpj,
      function (resp) {
        // resp = JSON.parse(resp);
        // this.form.controls.nome.setValue("");
        // this.form.controls.email.setValue("");
        // this.form.controls.endereco.setValue("");
        // this.form.controls.bairro.setValue("");
        // this.form.controls.numero.setValue("");
        // this.form.controls.cep.setValue("");
        // this.form.controls.complemento.setValue("");
        this.form.controls.nome.setValue(resp.razao_social);
        if (resp.nome_fantasia) {
          this.form.controls.fantasia.setValue(resp.nome_fantasia);
        }
        // if (resp.email) {
        //     this.form.controls.email.setValue(resp.email);
        // }
        if (resp.endereco && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.endereco.setValue(resp.endereco);
        }
        if (resp.bairro && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.bairro.setValue(resp.bairro);
        }
        if (resp.numero && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.numero.setValue(resp.numero_ed);
        }
        if (resp.cep && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.cep.setValue(resp.cep.replace(".", ""));
        }
        if (resp.complemento && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.complemento.setValue(resp.complemento);
        }
        if (resp.email && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.email.setValue(resp.email);
        }
        if (resp.estado && resp.cidade) {
          this.form.controls.uf.setValue(resp.estado);
          this.searchCities(resp.cidade);
        }
        let situacao = "-";
        let tipo = "-";
        let atividadePrincipal = "-";
        let naturezaJuridica = "-";
        let telefone = "-";
        let atualizacao = resp.ultima_atualizacao
          ? resp.ultima_atualizacao.substr(0, 10)
          : "";
        if (resp.situacao) {
          situacao = resp.situacao;
        }
        if (resp.motivo_situacao) {
          situacao += " - " + resp.motivo_situacao;
        }
        if (resp.data_situacao) {
          situacao += " - " + resp.data_situacao;
        }
        if (resp.tipo) {
          tipo = resp.tipo;
        }
        if (resp.atividade_principal && resp.atividade_principal[0]) {
          atividadePrincipal =
            resp.atividade_principal[0].code +
            " - " +
            resp.atividade_principal[0].text;
        }
        if (resp.natureza_juridica) {
          naturezaJuridica = resp.natureza_juridica;
        }
        if (resp.telefone) {
          telefone = resp.telefone;
        }
        let str = `<thead><tr><th colspan="2" scope="col">${cnpj}</th></tr></thead>
            <tr><td>Situação</td><td>${situacao}</td></tr>
            <tr><td>Tipo</td><td>${tipo}</td></tr>
            <tr><td>Atividade Principal</td><td>${atividadePrincipal}</td></tr>
            <tr><td>Natureza Jurídica</td><td>${naturezaJuridica}</td></tr>
            <tr><td>Telefone</td><td>${telefone}</td></tr>
            <tr><td>Atualização</td><td>${atualizacao}</td></tr>`;
        this.tableInfoDoc = str;
      }.bind(this)
    );
  }

  onSubmit() {
    this.error = false;
    if (!this.form.valid) {
      this.error = true;
      this.errorMsg = "Confira o formulário corretamente!";
      return;
    }
    if (this.form.value.nascimento) {
      if (typeof this.form.value.nascimento === "object") {
        this.form.value.nascimento = formatDate(
          this.form.value.nascimento,
          "dd/MM/yyyy",
          "en"
        );
      } else {
        this.form.value.nascimento =
          this.form.value.nascimento
      }
    }

    if (!this.usuarioService.loading) {
      this.usuarioService.cadastraRepresentante(
        this.registro,
        {
          ...this.form.value,
          usuario_cadastro: this.initProvider.usuario.id,
          tipo_funcionario: "R",
        },
        this.callback.bind(this),
        this.callbackError.bind(this)
      );
    }
  }

  callback(resp) {
    this.page.emit(2);
    if (this.registro) {
      Swal.fire(
        $localize`Registro`,
        this.SITE.menssagemAposCadastro
          ? this.SITE.menssagemAposCadastro
          : $localize`Cadastrado com sucesso. Aguarde avaliação da administração!`,
        "success"
      );
      $("#cadastraModal").modal("hide");
      this.router.navigate(["login"]);
    } else {
      Swal.fire(
        $localize`Cliente`,
        this.SITE.menssagemAposCadastro
          ? this.SITE.menssagemAposCadastro
          : $localize`Cadastrado com sucesso!`,
        "success"
      );
    }
  }

  callbackError(error) {
    if (error.status === 400) {
      this.toastService.warning(JSON.parse(error._body).detail, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      });
    } else if (error.status === 403) {
      this.toastService.warning($localize`Usuario não autenticado`, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      });
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
    } else if (error.status === 500) {
      this.toastService.warning($localize`Algo deu errado`, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      });
    } else {
      this.toastService.warning($localize`Algo deu errado`, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      });
    }
  }

  formatDocument(event) {
    let value = event.target.value;
    if (value == "CPF") {
      this.documentMask = "000.000.000-00";
      this.form.controls.numdocumento.setValidators([
        Validators.required,
        this.validaCPF,
      ]);
    } else {
      this.documentMask = "00.000.000/0000-00";
      this.form.controls.numdocumento.setValidators([
        Validators.required,
        this.validaCNPJ,
      ]);
    }
  }

  searchCities(cidade: string = null) {
    let uf = this.form.value.uf;
    this.usuarioService.cidadesPorUf(
      uf,
      function (resp) {
        this.cities = resp;
        this.cities.forEach((c) => {
          c.nome = c.nome.toLocaleUpperCase();
        });
        if (cidade) {
          //this.form.controls.cidade.setValue(cidade);
          setTimeout(
            function () {
              let city = this.cities.filter(
                (c) => c.nome === cidade.toUpperCase()
              );
              this.form.controls.cidade.setValue(city[0].id);
            }.bind(this),
            1000
          );
        }
      }.bind(this)
    );
  }

  ngOnInit() {
    if (this.edit) {
      if (this.selectedClient.tipodocumento == "CPF") {
        this.documentMask = "000.000.000-00";
      } else {
        this.documentMask = "00.000.000/0000-00";
      }
      this.form.controls.nome.setValue(this.selectedClient.nome);
      this.form.controls.bairro.setValue(this.selectedClient.bairro);
      this.form.controls.cep.setValue(this.selectedClient.cep);
      this.form.controls.numero.setValue(this.selectedClient.numero);
      this.form.controls.telefone.setValue(this.selectedClient.telefone);
      this.form.controls.endereco.setValue(this.selectedClient.endereco);
      this.form.controls.complemento.setValue(this.selectedClient.complemento);
      this.form.controls.ddd.setValue(this.selectedClient.ddd);
      this.form.controls.telefone.setValue(this.selectedClient.telefone);
      this.form.controls.telefoneWhatsapp.setValue(
        this.selectedClient.telefonewhatsapp
      );
      this.form.controls.dddWhatsapp.setValue(this.selectedClient.dddwhatsapp);
      this.form.controls.contato.setValue(this.selectedClient.contato);
      this.form.controls.fantasia.setValue(this.selectedClient.fantasia);
      this.form.controls.email.setValue(this.selectedClient.email);
      this.form.controls.observacao.setValue(this.selectedClient.observacao);
      this.form.controls.tipodocumento.setValue(
        this.selectedClient.tipodocumento
      );
      this.form.controls.numdocumento.setValue(
        this.selectedClient.numdocumento
      );
      this.form.controls.uf.setValue(this.selectedClient.uf);
      this.searchCities(this.selectedClient.nomecidade || this.selectedClient.cidade);
      if (this.form.value.nascimento) {
        this.form.controls.nascimento.setValue(
          this.selectedClient.nascimento.slice(-2) +
          "-" +
          this.selectedClient.nascimento.slice(5, 7) +
          "-" +
          this.selectedClient.nascimento.slice(0, 4)
        );
        // this.form.controls.cidade.setValue(this.selectedClient.cidade)
      }
    }
  }

  validaCPF(c: FormControl) {
    let cpf = c.value;
    let rtn = { validaCPF: { valid: false } };
    if (!cpf || cpf == "") return rtn;
    cpf = cpf.replace(/[^\d]+/g, "");
    if (
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    )
      return rtn;
    let add = 0;
    let rev = 0;
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(9))) return rtn;
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(10))) return rtn;

    return null;
  }

  sanitizeInput(event: any) {
    const inputValue: string = event.target.value;
    const sanitizedValue = this.sanitizeString(inputValue);
    this.form.controls.observacao.setValue(sanitizedValue);
  }

  sanitizeString(input: string): string {
    // Remove aspas simples e duplas
    const sanitizedInput = input.replace(/['"]/g, "");
    return sanitizedInput;
  }

  validaCNPJ(c: FormControl) {
    return validaCNPJValidator(c);
  }

  onSubmitEdit() {
    console.log(this.selectedClient);
  }
}
